import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { ApiResponsePaginated } from "@defs/api-response";
import { IUser } from "@defs/user";

interface UsersState {
  data: IUser[];
  loading: boolean;
  error: boolean;
  paginated: {
    current: number;
    total: number;
    data: IUser[];
    loading: boolean;
    bySearch: boolean;
  };
}

const initialState: UsersState = {
  data: [],
  loading: true,
  error: false,
  paginated: {
    current: 1,
    total: 0,
    data: [],
    loading: true,
    bySearch: false,
  },
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    resetList( state ) {
      state.loading = true;
      state.data = [];
    },

    reset(state) {
      state.loading = true;
      state.data = [];
      state.paginated.current = 1;
      state.paginated.total = 0;
      state.paginated.data = [];
      state.paginated.loading = true;
      state.paginated.bySearch = false;
    },
  },
  extraReducers: {
    "users/list/pending": (state) => {
      state.data = [];
      state.loading = true;
    },

    "users/list/fulfilled": (state, action: PayloadAction<IUser[]>) => {
      state.loading = false;
      state.data = action.payload;
    },

    "users/list/paginated/pending": (state, action: PayloadAction<number>) => {
      state.paginated.loading = initialState.paginated.loading;
      state.paginated.data = initialState.paginated.data;
      state.paginated.total = initialState.paginated.total;
      state.paginated.current = action.payload;
      state.paginated.bySearch = false;
    },

    "users/list/paginated/fulfilled": (
      state,
      action: PayloadAction<ApiResponsePaginated<IUser[]>>
    ) => {
      const { data, meta } = action.payload;

      state.paginated.loading = false;
      state.paginated.data = data;
      state.paginated.current = meta.current_page;
      state.paginated.total = meta.total;
    },

    "user/search/pending": (state) => {
      state.error = false;
      state.paginated.loading = true;
      state.paginated.bySearch = true;
    },

    "user/search/fulfilled": (state, action: PayloadAction<IUser[]>) => {
      state.paginated.loading = false;
      state.paginated.data = action.payload;
      state.paginated.current = 1;
      state.paginated.total = action.payload.length;
    },
  },
});

export const usersActions = usersSlice.actions;

export default usersSlice.reducer;
